import { ToastContainer } from "react-toastify";
import { useClients } from "./useClients";
import styles from './Clients.module.css';
import ArrowBelow from '../../assets/arrow_below.svg';
import lineTableItems from '../../assets/line_table_items.svg';

const Clients = () => {
    const { clients, clientTableLineId, handleRowClick } = useClients();
    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                <img src={ArrowBelow} alt="Seta para baixo" />
                <h4 className={styles.headerInfo}>Tabela de Clientes</h4>
                <img className={styles.line} src={lineTableItems} alt="Linha" />
            </div>
            <div className={styles.tableItems}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={styles.scrollableHeader}>Id</div></th>
                            <th><div className={styles.scrollableHeader}>Código</div></th>
                            <th><div className={styles.scrollableHeader}>Nome</div></th>
                            <th><div className={styles.scrollableHeader}>CNPJ</div></th>
                            <th><div className={styles.scrollableHeader}>Email</div></th>
                            <th><div className={styles.scrollableHeader}>Telefone</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients.length > 0 ? (
                            clients.map((client) => (
                                <tr 
                                    key={client.id}
                                    onClick={() => handleRowClick( client )}
                                    className={client.id === clientTableLineId ? styles.selectedRow : ''}>
                                    <td>{client.id}</td>
                                    <td>{client.code}</td>
                                    <td>{client.name}</td>
                                    <td>{client.cnpj}</td>
                                    <td>{client.email}</td>
                                    <td>{client.phone}</td>
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Clients;